import { render, staticRenderFns } from "./SectionRegions.vue?vue&type=template&id=5b0a2ac1&scoped=true"
import script from "./SectionRegions.vue?vue&type=script&lang=js"
export * from "./SectionRegions.vue?vue&type=script&lang=js"
import style0 from "./SectionRegions.vue?vue&type=style&index=0&id=5b0a2ac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a2ac1",
  null
  
)

export default component.exports